import {Algorithm} from "./Algorithm";
import {UserInputOptionSelector} from "./UserInputOptionSelector";

export class Compass extends Algorithm {

  constructor(container) {
    super(container);

    this.weatherOverrides = {
      CLO: {
        0.5: "sunny",
        0.75: "rainy",
        1: "snowing",
      }
    };
  }

  buildRangesMap() {
    this.rangesMap = this.userCombinationData.map(({key, title}, index) => {
      const [CLO, MET] = title.match(/\d+\.?\d*/g).map(Number); // extract numbers from the title
      return {key, CLO, MET, index};
    });
  }

  initUserInputs() {
    super.initUserInputs();

    this.clothingFactorSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="CLO"]`));
    this.clothingFactorSelector.on("userInputValueChanged", (value) => this.onUserInput(value));

    this.metabolicRateSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="MET"]`));
    this.metabolicRateSelector.on("userInputValueChanged", (value) => this.onUserInput(value));
  }

  onUserInput(value) {
    const targetCombination = this.findUserCombination(this.clothingFactorSelector.getRealValue(), this.metabolicRateSelector.getRealValue());

    // Update KPIs
    this.selectKPIs(targetCombination.key);

    // Update charts
    Object.entries(this.charts).forEach(([name, chart]) => {
      chart.loadDataset(targetCombination.index);
    });

    this.sendWeatherOverride();
  }


  sendWeatherOverride() {
    if (!this.isActive) return;

    const CLO = this.clothingFactorSelector.getRealValue();

    app.sendScreenBridgeMessage(`weatherOverride ${this.weatherOverrides.CLO[CLO] ?? "none"}`);
  }

  start() {
    super.start();

    this.sendWeatherOverride();
  }

  findUserCombination(CLO, MET) {
    // Let's return the entry where the value fits the correct values
    // Returns the first element if there is no match (which should not happen if data is set correctly)
    return this.rangesMap.find(entry => entry.CLO === CLO && entry.MET === MET) ?? this.rangesMap[0];
  }

  onBuildingChange(type) {
    super.onBuildingChange(type);

    // Dummy equipment -  Set all related equipment to active
    this.updateAllBuildingsEquipments("active");
  }

  resetUserInputs() {
    this.clothingFactorSelector.reset();
    this.metabolicRateSelector.reset();
  }

}
